import { EmptyUUID } from './constants'
import { falsyOrUUID } from './falsyOrUUID'

export const firstUUIDOrEmpty = (...uuids: (string | undefined)[]) => (uuids && uuids.find(uuid => !!falsyOrUUID(uuid))) || EmptyUUID
